const ERROR_LIST = {
    "DashboardAnnouncement": "An unexpected error occurred in Announcement",
    'DashboardGallery': "An unexpected error occurred in Gallery",
    "DashboardAward": "An unexpected error occurred Award",
    "DashboardCelebration": "An unexpected error occurred in Celebration",
    'DashboardFeaturePost': "An unexpected error occurred in FeaturePost",
    'DashboardLike': "An unexpected error occurred in Feed Like",
    'DashboardComment': "An unexpected error occurred in Feed Comment",
    'TicketDetail': "An unexpected error occurred in Feed in Get Ticket",
    'DefaultError': "Something went wrong",
    'AwardYear': "An unexpected error occurred in Year",
    'AwardMasterData': "Failed to fetch award master data",
    'ArticleData': "Failed to fetch article master data",
    'UploadFileError': "Error in uploading file",
    'UploadFileMsgError': "Invalid file type. Please upload a supported format",
    'DashboardLanguage': 'Failed to fetch language master type',
    'SendUsFeedBack': "An unexpected error occurred in Feedback",
    'RaiseaFlag': "An unexpected error occurred in RaiseaFlag",
    'GalleryAddAlbum': "An unexpected error occurred in Add Album",
    'GalleryGetAlbum': "An unexpected error occurred in Album",
    'TicketUpdate': "An unexpected error occurred in ticket update",
    'EmployeeListOnFeedDetails': "An unexpected error occurred in Employee List",
    'FeedLikePostOnFeedDetails': "An unexpected error occurred in Feed Like",
    'FeedPostOnFeedDetails': "An unexpected error occurred in Feed Details",
    'FeedPostOnComment': "An unexpected error occurred in Comment",
    'DashboardFeed': "An unexpected error occurred in Feed",
    'MakeFeatured':'An unexpected error occurred in Featured Post Api',
    'FeedCount':'An unexpected error occurred in FeedCount Api',
    'MasterDataType': "Failed to fetch master type data",
    'CreateGroup':'Failed to create group',
    'DynamicMenu': "Failed to fetch dynamic menu",
    'EmployeeListDataError': "Failed to fetch employee list",
    'NotificationError': "Failed to fetch notification",
    'AwardImagesError': "Awards Images is not there!!!",
    'VersionError': "Failed to fetch version",
    'ExcelUploadError': "Failed to upload Excel",
    'EmpPhoto': "An unexpected error occurred in Get Photos Api",
    'EmpPostPhoto': "An unexpected error occurred in Post Photos Api",
    'UpdateOfficialEmail':"An unexpected error occurred in Update Official Email",
    'PostEmployeeFollow':'An unexpected error occurred in Employee Follow',
    'PostDocument':'An unexpected error occurred in document post',
    'PostFolder':'An unexpected error occurred in Folder Create',
    'GetFolder':'An unexpected error occurred in Get Folder Record',
    'GetMessage':'An unexpected error occurred in Post Message Record',
    'EmpAssessmentList':'An unexpected error occurred in Employee Assessment List',
    'MakeUnPin':'An unexpected error occurred in Document Pin/Unpin',
    'ExirRequest':'An unexpected error occurred in Exit Request',
}

export default ERROR_LIST;